import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { useParams, useSearchParams } from "react-router-dom";
import "../donation-widget/donation-widget.scss";
import "./product-donation-widget.scss";
import { loadStripe } from "@stripe/stripe-js";
import axios from 'axios';
import { GET_PLEDGE_DETAIL, GET_PRODUCT_BY_ID, GET_PRODUCT_BY_LINK, GET_RAISED_DONATIONS } from '../../../constants/endpoints';
import { FormProvider, useForm } from "react-hook-form";
import PaymentRequestForm from '../../../shared/payment-request-form/payment-request-product.form';
import { Elements } from '@stripe/react-stripe-js';
import DonorUserInfo from '../donation-widget/donor-user-info';
import calculateCCAfterFee from '../../../utils/stripe-payment-fee.util';
import { getTextColorByBG, getBgColor, getHoverColor } from '../../../utils/utils';
import getFormattedDateTime from '../../../utils/date-time-format';
import PaymentForm from '../donation-widget/payment-form-product';
import FieldError from '../../../shared/fields-errors/field-error';
import { ENVIRONMENT_CONSTANT } from '../../../constants/env.constant';
import DonorCommentsTemplate from '../donation-widget/donor-comments-template';
import { useSquarePayment } from '../payment-processors/square/hooks/useSquarePayment';
import SquareCard from '../payment-processors/square/card/square-card';
import SquareGoogleApplePay from '../payment-processors/square/square-google-apple-pay/square-google-apple-pay';
import { CURRENCY_CODE_SIGN_MAPPING } from '../../../constants/currency-code-sign.constant';
import DynamicFieldsWrapper from '../custom-fields/shared/dynamic-fields/dynamic-fields-wrapper';
import PledgeUserInfo from '../donation-pledge/pledge-user-info';
import PledgeConfirmation from '../../../shared/pledge-confirmation/pledge-confirmation';
import { useCustomFields } from '../custom-fields/hooks/custom-fields.hook';


const publishKey = process.env.REACT_APP_STRIPE_PUBLISH_KEY;
function ProductDonationWidget(props) {
    const [stripeButtonElementLoader, setStripeButtonElementLoader] = useState(false);
     const { initializeSquare, squareInstance } = useSquarePayment();
    const { customFields, getEntityFields, requestLoader }= useCustomFields();
    //props start
    const requestFormRef = useRef(null);
    const donorInfoRef = useRef(null);
    const logoBaseUrl = ENVIRONMENT_CONSTANT.LOGO_BASE_URL;
    const [raisedDonations, setRaisedDonations] = useState({});
    const [productDetail, setProductDetail] = useState({});
    const [amount, setAmount] = useState(100);
    const [paymentFormAmount, setPaymentFormAmount] = useState(0);
    const [formStep, setFormStep] = useState('amount-selection');
    const [isGoogleApplePay, setIsGoogleApplePay] = useState(false);
    const [unitPrice, setUnitPrice] = useState(0);
    const [stripePromise, setStripePromise] = useState(null);
    const [pledgeInfo, setPledgeInfo] = useState({});
    const [loader, setLoader] = useState(true);

    //stripe appearance settings 
    const appearance = {
        theme: 'stripe',
    };
    //stripe settings to load widget
    const [options, setOptions] = useState({
        mode: 'payment',
        amount,
        currency: 'usd',
        paymentMethodCreation: 'manual',
        // Fully customizable with appearance API.
        appearance: appearance,
    });

    //getting url params
    const params = useParams();
    const [queryParams, setQueryParams] = useSearchParams();
    //saving product id from params
    // const productID = params.id;
    const link = params.link;
    const pledgeID = queryParams.get('pledge_token');
    const short_code = params.short_code;
    const showTitle = queryParams.get('show_title');
    const showSubtitle = queryParams.get('show_subtitle');
    const showLogo = queryParams.get('show_logo');
    const isMobile = queryParams.get('is_mobile');
    const [isEditingQty, setIsEditingQty] = useState(false);

    // animation code 
    const [navDirection, setNavDirection] = useState('forward'); 
   // animation code end
    

    //initializing for react form
    const methods = useForm();
    //getting different props from react forms
    const { register, trigger, handleSubmit, setValue, reset, clearErrors,
        unregister,
         watch, formState: { isValid, errors }, getValues, control } = methods;
         
    //watching form fields 
    const fieldsWatcher = watch();
    //props end

    //useEffect implementation start
    useEffect(() => {
        if(short_code){
            getProductInfo();
        }
    }, [short_code])


    //component functions start

    //getting raised donations from db
    const getRaisedDonation = async (product) => {
        axios.post(GET_RAISED_DONATIONS, product)
            .then((res) => {
                if (res?.data?.success) {
                    setRaisedDonations(res?.data?.response)
                }
            }).catch((error) => {

            })
    }

    //getting product detail from api
    const getProductInfo = async () => {
        axios.get(`${GET_PRODUCT_BY_LINK}${link}/${short_code}`)
            .then(async (res) => {
                if (res?.data?.status) {
                    //setting up global variables for stripe processing fee
                    window.stripe_flat_fee = parseFloat(res?.data?.response?.stripe_flat_fee);
                    window.stripe_percentage_fee = (parseFloat(res?.data?.response?.stripe_percentage_fee) / 100).toFixed(3);
                    window.current_payment_processor = res?.data?.response?.default_payment_processor;
                    
                    // res.data.response.donation_amount = {
                    //     ask_donors_cover_fee_default: res.data.response.ask_donor_to_cover_fee_default,
                    //     ask_donors_cover_fee: res.data.response.ask_donor_to_cover_fee,
                    // }
                    setProductDetail(res?.data?.response);
                    setValue('no_of_units', 1);
                    setAmount((res?.data?.response?.price_per_unit * 1) * 100);
                    setPaymentFormAmount(res?.data?.response?.price_per_unit * 1);
                    setUnitPrice(res?.data?.response?.price_per_unit);
                    //loading stripe start
                    if (res?.data?.response?.stripe_account_id && res?.data?.response?.default_payment_processor === 'Stripe') {
                        const stripePromise = await loadStripe(publishKey, {
                            stripeAccount: res?.data?.response?.stripe_account_id
                        });

                        setStripePromise(stripePromise)
                    }
                    //loading stripe end

                    //loading square sqk
                    if(res?.data?.response?.square?.location_id && res?.data?.response?.default_payment_processor === 'Square'){
                        initializeSquare(res?.data?.response?.square?.location_id);
                    }

                    if (parseFloat(res?.data?.response?.goal_amount)) getRaisedDonation(res?.data?.response);

                } else {
                    alert(res?.data?.message);
                    window.location.href = `${window.location.origin}/${short_code}`;
                }
            }).catch((error) => {
                alert('Unable to get information regarding this product');
            })
    }

    const returnSelectedAmount = () => {
        return parseFloat(paymentFormAmount)
    }

    //summary header amount — includes processing fee if checkbox is checked
    const getDisplaySummaryAmount = () => {
        const baseAmount = returnSelectedAmount();
        if (isNaN(baseAmount)) return 0;
        const isCoverFeeChecked = fieldsWatcher?.cover_processing_fee !== undefined
            ? fieldsWatcher?.cover_processing_fee
            : (getValues()?.cover_processing_fee !== undefined
                ? getValues()?.cover_processing_fee
                : !!productDetail?.donation_amount?.ask_donors_cover_fee_default);
        return isCoverFeeChecked ? parseFloat(calculateCCAfterFee(baseAmount)) : baseAmount;
    }

    //toggling quantity start
    const toggleQuantity = (type) => {
        let currentQuantityValue = getValues()?.no_of_units;
        if(type === 'increment'){
            if(!productDetail?.sell_after_out_of_stock && productDetail?.available_units){
                if(productDetail?.available_units > currentQuantityValue){
                    currentQuantityValue++
                }
            }else{
                currentQuantityValue++
            }
            
        }else{
            if(currentQuantityValue > 1){
                currentQuantityValue--
            }
        }

        setValue('no_of_units', currentQuantityValue);
        setAmount(((unitPrice)*currentQuantityValue) * 100);
        setPaymentFormAmount((unitPrice)*currentQuantityValue);
    }
    //toggling quantity end

    const setForm = (value) => {
        if (typeof (value) === 'boolean') {
            setIsGoogleApplePay(value);
        } else {
            setFormStep(value);
        }
    }

    //checking if form is valid to proceed next and previous start
    const checkIsFormValidToProceed = async () => {
        if (formStep === 'amount-selection') {
            // chooseAmountValidation();
            if (customFields?.length > 0) {
                setFormStep('custom_fields')
            } else if (productDetail?.google_apple_pay && isGoogleApplePay) {
                setFormStep('request_button')
            } else {
                setFormStep('info');
            }
        } else if (formStep === 'info') {
            if (!isValid) {
                trigger();
            } else {
                clearErrors();
                setFormStep('payment');
            }
        } else if (formStep === 'request_button') {
            setFormStep('info');
        }else if(formStep === 'custom_fields'){
            const isValid = await trigger("field_answers");
            if(isValid){
                customFieldAction();
            }
            
        }
    }
    //checking if form is valid to proceed next and previous end

    // confirmation screen or redirect after payment
    const onPaymentSuccess = (message) => {
        if (productDetail?.is_redirection_url && productDetail?.redirection_url) {
            const redirectURL =
                (productDetail?.redirection_url?.includes('http') || productDetail?.redirection_url?.includes('https')) ?
                    productDetail?.redirection_url : 'https://' + productDetail?.redirection_url;
                    window.open(redirectURL, '_self');
        } else {
            setFormStep('confirmation')
        }
    }
    
    //validating donor info screen
    const validateDonorInfo = () => {
        if (isValid) {
            if(!requestFormRef?.current?.removeFeeForACH && productDetail?.donation_amount?.ask_donors_cover_fee_default){
                setValue('cover_processing_fee', true);
                const amount = returnSelectedAmount();
               requestFormRef?.current?.setFinalAmount(parseFloat(calculateCCAfterFee(amount)));
               setAmount(Math.round(parseFloat(calculateCCAfterFee(amount)) * 100));
            }else{
                setValue('cover_processing_fee', false);
                requestFormRef?.current?.setFinalAmount(returnSelectedAmount());
                setAmount(Math.round(returnSelectedAmount() * 100));
            }
            setFormStep('payment');
        } else {
            trigger();
        }
    }

    //returning final payload for donation
    const [finalScreenAmount, setFinalScreenAmount] = useState(0);
    const returnDonationPayload = (formData) => {
        const donationPayload = {
            campaign_id: productDetail?.donation_amount?.campaign_id,
            donation_type: 'One-Time',
            campaign_title: productDetail?.campaign_title,
            amount: paymentFormAmount,
            masjid_id: productDetail?.masjid_id,
            stripe_account_id: (productDetail?.default_payment_processor === 'Square' ? productDetail?.square?.merchant_id : productDetail?.stripe_account_id),
            // stripe_account_id: productDetail?.stripe_account_id,
            return_url: window.location.origin,
            ...getValues(),
            ...(formData ? formData : {})
        }

        //checking if pledge id is available then setting up pledge id for the form
        if(pledgeID){
            donationPayload.pledge_id = pledgeID;
        }

         if(donationPayload?.field_answers?.length > 0){
            donationPayload.field_answers = donationPayload?.field_answers?.flatMap(it => it.answers);
        }

        //replacing amount based on stripe fee
        if (donationPayload?.cover_processing_fee) {
            const finalAmount = parseFloat(calculateCCAfterFee(donationPayload.amount));
            donationPayload.stripe_processing_fee = (parseFloat(finalAmount) - donationPayload.amount).toFixed(2);
            donationPayload.amount = finalAmount;
        } else {
            donationPayload.stripe_processing_fee = 0;
        }
        setFinalScreenAmount((donationPayload.amount)?.toFixed(2))
        // setAmount(donationPayload.amount);
        //after replacing amount and setting up stripe fee returning payload to child
        return donationPayload;
    }

    const getDonationPercentage = () => {
        const rawPercentage = ((raisedDonations?.total_unit_purchased / productDetail?.goal_amount) * 100);
        if (isNaN(rawPercentage) || !isFinite(rawPercentage) || rawPercentage <= 0) {
            return '0%';
        }
        const percentage = Math.ceil(rawPercentage);
        return (percentage > 100 ? 100 : percentage) + '%';
    }

    //register and unregister the processing fee checkbox
    useEffect(() => {
        if (formStep === 'payment' || formStep === 'amount-selection'|| formStep === 'request_button') {
            register('cover_processing_fee');
        } else {
            unregister('cover_processing_fee');
        }
    }, [formStep])
    //component functions end

    useEffect(() => {
        if(formStep === 'request_button'){
            if(!productDetail?.donation_amount?.ask_donors_cover_fee && productDetail?.donation_amount?.ask_donors_cover_fee_default){
                register("cover_processing_fee", {
                    value: true
                });
            }
        }
    }, [formStep]);

            //pledge flow start
            const [formMappingLoader, setFormMappingLoader] = useState(pledgeID ? true : false);
            useEffect(() => {
                if(pledgeID && productDetail?.id && !stripeButtonElementLoader){
                    getPledgeByID();
                }
            }, [pledgeID ,productDetail, stripeButtonElementLoader]);
        
            const getPledgeByID = () => {
                setFormMappingLoader(true);
                axios.get(GET_PLEDGE_DETAIL + pledgeID)
                .then((res) => {
                    setFormMappingLoader(false);
                    if(res?.data?.status){
                        setPledgeInfo(res?.data?.response)
                        //setting up all the required fields for donation form
                        reset({
                            first_name: res?.data?.response?.donor?.first_name,
                            last_name: res?.data?.response?.donor?.last_name,
                            email: res?.data?.response?.donor?.email,
                            phone: res?.data?.response?.donor?.phone,
                            donation_designation: res?.data?.response?.donation_designation,
                            donor_comments: res?.data?.response?.donor_comments,
                        });
                        setValue('no_of_units', res?.data?.response?.no_of_units);
                        setAmount((productDetail?.price_per_unit * res?.data?.response?.no_of_units) * 100);
                        setPaymentFormAmount(productDetail?.price_per_unit * res?.data?.response?.no_of_units);
                        setUnitPrice(productDetail?.price_per_unit);
    
                        //setting up the amount
                        if(productDetail?.donation_amount?.ask_donors_cover_fee_default){
                            const amt = Math.round(parseFloat(calculateCCAfterFee(res.data.response?.amount)));
                            setAmount(amt);
                        }else{
                            setAmount(res.data.response?.amount);
                        }
                        //setting up the current screen and selected donation type
                        isGoogleApplePay ? setFormStep('request_button') :  setFormStep('info');
                    }
                }).catch((error) => {
                    setFormMappingLoader(false);
                })
            }
            //pledge flow end

    useEffect(() => {
        if (!stripeButtonElementLoader) {
            setLoader(false);
        }
    }, [stripeButtonElementLoader]);

    //custom fields 
    useEffect(() => {
        if (productDetail?.donation_amount?.campaign_id) {
            getEntityFields(productDetail?.donation_amount?.campaign_id);
        }
    }, [productDetail]);
        const customFieldAction = () => {
        if (productDetail?.google_apple_pay && isGoogleApplePay) {
            setFormStep('request_button');
        } else {
            setFormStep ('info')
        }
    }

        const formStepLabel = formStep === 'amount-selection' ? 'Choose Quantity' :
            formStep === 'info' ? ((productDetail?.activate_pledge && donorInfoRef?.current?.payLater) ? 'Pledge Form' : 'Your Information') :
                formStep === 'request_button' ? 'Payment' :
                    formStep === 'custom_fields' ? 'Additional Information' :
                        formStep === 'payment' ? 'Payment' : 'Success';

    return (
        <>
        {showLogo && (
                    <style>
                        {`
                        html .bg-white,
                        body .bg-white {
                            background: transparent !important;
                        }
                        .form--header{
                         background: transparent !important;
                        }
                        `}
                    </style>
        )}
            {
                productDetail?.is_delete === true ?
                   <div className="container py-5">
                        <div className="row align-items-center justify-content-center min-vh-75">

                            <div className="col-lg-6 text-center text-lg-start mb-5 mb-lg-0">

                                <span className="error-badge">404 Error</span>

                                <h1 className="error-title mt-3">
                                    Oops! Page Not Found
                                </h1>

                                <p className="error-text mt-4">
                                    We’ve tried searching but couldn’t find the page you’re looking for.
                                </p>

                                <p className="error-text">
                                    Not to worry — let's help you get back on track.
                                </p>

                                <a
                                    href="https://donation.dev.masjidal.com/"
                                    className="btn btn-primary mt-4 px-4 py-2"
                                >
                                    Go to Donation Portal
                                </a>

                                <p className="mt-4 small text-muted">
                                    Are you a Masjidal organization?{" "}
                                    <a
                                        href="https://donation.dev.masjidal.com/"
                                        className="text-decoration-none fw-semibold"
                                    >
                                        Click here
                                    </a>
                                    .
                                </p>

                            </div>

                            <div className="col-lg-6 text-center ">
                                <img
                                    src="../../../img/404.jpg"
                                    alt="404"
                                    className="img-fluid rounded error-image"
                                />
                            </div>

                        </div>
                    </div> :
                    (productDetail?.activate_pledge === false && window.location.href?.includes("pledge")) ? 
                    <div className="container py-5">
                        <div className="row align-items-center justify-content-center min-vh-75">

                            <div className="col-lg-6 text-center text-lg-start mb-5 mb-lg-0">

                                <span className="error-badge">404 Error</span>

                                <h1 className="error-title mt-3">
                                    Oops! Page Not Found
                                </h1>

                                <p className="error-text mt-4">
                                    We’ve tried searching but couldn’t find the page you’re looking for.
                                </p>

                                <p className="error-text">
                                    Not to worry — let's help you get back on track.
                                </p>

                                <a
                                    href="https://donation.dev.masjidal.com/"
                                    className="btn btn-primary mt-4 px-4 py-2"
                                >
                                    Go to Donation Portal
                                </a>

                                <p className="mt-4 small text-muted">
                                    Are you a Masjidal organization?{" "}
                                    <a
                                        href="https://donation.dev.masjidal.com/"
                                        className="text-decoration-none fw-semibold"
                                    >
                                        Click here
                                    </a>
                                    .
                                </p>

                            </div>

                            <div className="col-lg-6 text-center ">
                                <img
                                    src="../../../img/404.jpg"
                                    alt="404"
                                    className="img-fluid rounded error-image"
                                />
                            </div>
                        </div>
                    </div> :
                     (productDetail?.donation_amount?.id) ? <FormProvider className={`${!requestLoader ? 'd-block' : 'd-block'}`} {...methods}>
                        <div className='product-widget-wrapper'  style={{
                         background: productDetail?.is_header_background_color
                         ? `linear-gradient(180deg, ${getBgColor(productDetail?.header_background_color)} 0%, #ffffff 50%)`
                        : "#ffffff",
                         minHeight: "100vh",
                         '--checkbox-check-color': getTextColorByBG(productDetail?.primary_color),}}>
                        {
                            productDetail?.is_display_logo || !productDetail?.is_display_campaign_title
                                || productDetail?.is_subtitle ?
                                <div className={`custom-page-header ${!(productDetail?.is_display_logo && productDetail?.image_location && !showLogo) ? 'pt-4' : ''}`}>
                                    {
                                        productDetail?.is_display_logo && productDetail?.image_location && !showLogo?
                                            <div className='col-12 pt-2'>
                                                <img className='donation-widget-logo'  src={`${logoBaseUrl}${productDetail?.image_location}`} alt="Masjid Image" />
                                            </div> : ''          
                                    }


                                    {/* {
                                        !productDetail?.is_display_campaign_title ?
                                            <div className='col-12 mt-3'>
                                                <span style={{
                                                    color:
                                                        (productDetail?.is_header_background_color ?
                                                            getTextColorByBG(productDetail?.header_background_color) : 'black')
                                                }} className='custom-header-title'>{productDetail?.campaign_title}</span>
                                            </div> : ''
                                    }

                                    {
                                        productDetail?.is_subtitle ?
                                            <div className='col-12 mt-2 mb-4'>
                                                <span style={{
                                                    color:
                                                        (productDetail?.is_header_background_color ?
                                                            getTextColorByBG(productDetail?.header_background_color) : 'black')
                                                }} className='custom-header-subtitle'>{productDetail?.subtitle}</span>
                                            </div> : ''
                                    } */}

                                </div> : ''
                        }


                        {/* {
                            productDetail?.is_header_background_color ?
                                <div style={{ backgroundColor: productDetail?.header_background_color }} className='form--header'></div>
                                : ''
                        } */}


                            {
                                <div className='container' style={{
                                    display: loader ? 'none' : 'block'
                                }}>
                                    <div className={`col-xxl-4 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 offset-md-2 offset-xxl-4 offset-xl-3 offset-lg-3 donation-form-wrapper ${!(productDetail?.is_display_logo && productDetail?.image_location && !showLogo) ? 'pt-3' : ''}`}>

                                        {
                                            parseFloat(productDetail?.goal_amount) && formStep !== 'confirmation' && !showLogo ?
                                                <div className='row card-header position-relative'>
                                                   
                                                    <div className='col-12'>
                                                          <div className='text-center'>
                                                                 <h1 className='header-title'>{productDetail?.campaign_title}</h1>
                                                                 <p className='header-subtitle mb-2'>{productDetail?.subtitle}</p>
                                                            </div>

                                                        {/* <div className='donation-widget'>
                                                            <div className='donation'>
                                                            style={{ width: getDonationPercentage() }} 
                                                                <div className='donation__received' style={{ 
                                                                    width: getDonationPercentage(),
                                                                    backgroundColor: productDetail?.primary_color ? (productDetail?.primary_color) : '#015B97'
                                                                 }}></div>
                                                            </div>  

                                                            <div className='d-flex justify-content-between align-items-center p-4'>
                                                                <div className='text-center d-grid'>
                                                                    <span className='text-black'>{raisedDonations?.total_unit_purchased}</span>
                                                                    <span className='text-black'>Raised</span>
                                                                </div>
                                                                <div className='text-center d-grid'>
                                                                    <span className='text-black'>{raisedDonations?.donations}</span>
                                                                    <span className='text-black'>Donations</span>
                                                                </div>
                                                                <div className='text-center d-grid'>
                                                                    <span className='text-black'>{productDetail?.goal_amount}</span>
                                                                    <span className='text-black'>Goal</span>
                                                                </div>
                                                            </div>
                                                        </div>  */}

                                                    </div>
                                                </div> : ''
                                        }

                                        {/* <div className={`card rounded-3 product-form-card mt-3 mb-4  ${formMappingLoader ? 'd-none' : ''}`} > */}
                                        <div className={`card rounded-3 product-form-card mt-3 mb-4 overflow-hidden ${formMappingLoader ? 'd-none' : ''}`} >
                                            <div   className={`border-0 card-header ${
                                              formStep === "confirmation" ? "p-0 m-0" : "pb-0"
                                               }`}>
                                                {
                                                    formStep == 'amount-selection' ? 
                                                    <>
                                                    <div className='goal-bar mb-4'>
                                                                <div className='goal-track'>
                                                                    <div
                                                                        className='goal-fill'
                                                                        style={{
                                                                            width: getDonationPercentage(),
                                                                            backgroundColor:  '#16A34A'
                                                                        }}
                                                                    ></div>
                                                                </div>
                                                                <div className='goal-meta'>
                                                                    <strong>
                                                                      <span>{raisedDonations?.total_unit_purchased}</span>   of <span> {productDetail?.goal_amount} {productDetail?.unit_label ? productDetail?.unit_label : 'raised'}</span>
                                                                    </strong>
                                                                    <span>{getDonationPercentage()}</span> 
                                                                 
                                                                </div>
                                                            </div>
                                                              <hr 
                                                            className='full-divider my-0 mt-4' 
                                                            style={{
                                                                marginLeft: '-30px',
                                                                width: 'calc(100% + 60px)',  
                                                            }} 
                                                            />
                                                    </>
                                                    : ''
                                                }
                                                <div className="align-items-center ">
                                                    <div className="">
                                                        <div className={`mb-0 text-white d-flex ${isMobile ? 'justify-content-start' : 'justify-content-between'} `}>
                                                   <div >
                                                            <div className='product-step-header  gap-3'>
                                                                {(formStep !== 'amount-selection' && formStep !== 'confirmation' && formStep !== 'pledge-confirmation') && 
                                                                (!productDetail?.sell_after_out_of_stock ? 
                                                                    (productDetail?.available_units === undefined || productDetail?.available_units > 0) ? true : false : true)  ?
                                                                    <div onClick={(() => setFormStep(
                                                                        (formStep === 'info' && isGoogleApplePay && productDetail?.google_apple_pay) ? 'request_button' :
                                                                        formStep === 'info' && customFields?.length > 0 ? 'custom_fields' :
                                                                            formStep === 'info' ? 'amount-selection' :
                                                                            formStep === 'custom_fields' ? 'amount-selection' :
                                                                            formStep === 'request_button' && customFields?.length > 0 ? 'custom_fields' :
                                                                                formStep === 'request_button' ? 'amount-selection' : 'info'
                                                                    ))} className=" back-button"
                                                                       style= {{'--hover-border-color': productDetail?.primary_color || 'red'}} >
                                                                         {/* <i className="fa-solid fa-chevron-left" style={{ color: '#555', fontSize: '14px' }}></i> */}
                                                                         <button className="back-button"  title="Go back">
                                                                          <svg width="15" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 3L5 8l5 5"></path></svg>
                                                                        </button>
                                                                    </div> : ''
                                                                }
                                                             
                                                                <div className='f-22  w-100 ' style={{  width: '100%', minWidth: '100%' }}>
                                                                    {(formStep !== 'amount-selection' && formStep !== 'confirmation' && formStep !== 'pledge-confirmation') ?
                                                                        <div className='product-step-summary-wrap'>
                                                                            <span className='product-step-summary'>
                                                                                <span className='product-step-title'>{productDetail?.unit_label.toUpperCase()}</span>
                                                                                <span className='product-step-meta'>
                                                                                    &times; {fieldsWatcher?.no_of_units || getValues()?.no_of_units || 1} &mdash; {CURRENCY_CODE_SIGN_MAPPING[productDetail?.currency] || '$'}{Number(getDisplaySummaryAmount() || 0).toFixed(2)}
                                                                                </span>
                                                                            </span>
                                                                        </div>
                                                                        : '' }

                                                                </div>  

                                                            </div>   
                                                            {
                                                                formStep !== "amount-selection" && (
                                                               <p className='step-title mt-3 mb-0 pb-0 text-uppercase'>{formStep === 'custom_fields' ? 'Additional Information' : ''}</p> 
                                                                )
                                                            }
                                                                 </div>          
                                                            {/* {
                                                                (formStep !== 'confirmation'  && formStep !== 'pledge-confirmation') ?
                                                                    <span className={`${isMobile ? 'mx-3' : ''}`}>
                                                                        <i className={`fa-circle me-2 ${formStep === 'amount-selection' ? 'fa-solid' : 'fa-regular'}`}></i>
                                                                         {
                                                                            customFields?.length > 0 ?
                                                                            <i className={`fa-circle me-2 ${formStep === 'custom_fields' ? 'fa-solid' : 'fa-regular'}`}></i> : ''
                                                                        }
                                                                        {isGoogleApplePay ? <i className={`fa-circle me-2 ${formStep === 'request_button' ? 'fa-solid' : 'fa-regular'}`}></i> : ''}
                                                                        <i className={`fa-circle me-2 ${formStep === 'info' ? 'fa-solid' : 'fa-regular'}`}></i>
                                                                        {(!donorInfoRef?.current?.payLater) ? <i className={`fa-circle me-2 ${formStep === 'payment' ? 'fa-solid' : 'fa-regular'}`}></i> : ''}
                                                                    </span> : ''
                                                            }  */}
                                                            {
                                                                (formStep !== 'confirmation' && formStep !== 'pledge-confirmation' && formStep !== 'payment' && !isMobile &&
                                                                (!productDetail?.sell_after_out_of_stock ? 
                                                                    (productDetail?.available_units === undefined || productDetail?.available_units > 0) ? true : false : true) 
                                                                    && (productDetail?.activate_pledge && donorInfoRef?.current?.payLater ? true : false)
                                                                ) ?
                                                                    <i onClick={checkIsFormValidToProceed} className="f-24 float-end cursor-pointer fa-solid fa-arrow-right me-2"></i> :
                                                                    ''
                                                            }

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-body main-widget p-4 pt-0">

                                                {/* {
                                                    productDetail?.is_subtitle && formStep === 'amount-selection'?
                                                        <div className='col-12 mt-2 mb-3 text-center text-black'>
                                                            <span className='custom-header-subtitle'>{productDetail?.subtitle}</span>
                                                        </div> : ''
                                                } */}
                                                {/* <div className={formStep !== 'amount-selection' ? 'd-none' : ''}> */}
                                                <div className={ formStep !== "amount-selection" ? "d-none" : `step-content ${navDirection === "forward" ? "slide-forward": "slide-backward" }`}>
                                                    <div className='d-flex flex-column justify-content-center align-items-center'>
                                                        {/* <h5 className='text-center'>Unit Price: ${productDetail?.price_per_unit}</h5> */}
                                                       
                                                           <div className="price-block">
                                                            <div className="price-amount">
                                                                <span className="price-currency">
                                                                    {CURRENCY_CODE_SIGN_MAPPING[productDetail?.currency]}
                                                                </span>

                                                                <span className="price-value">
                                                                    {productDetail?.price_per_unit}
                                                                </span>
                                                            </div>

                                                            <div className="price-unit">
                                                                <span>
                                                                   PER {productDetail?.unit_label
                                                                    ? productDetail?.unit_label.toUpperCase()
                                                                    : 'MEMBER'}
                                                                </span>
                                                               
                                                            </div>
                                                        </div>
                                                            
                                                           {
                                                                productDetail?.sell_after_out_of_stock || 
                                                                (productDetail?.available_units === undefined || productDetail?.available_units > 0) ? 
                                                                <>
                                                                <span className='quantity-label text-center mb-1 f-14'>Quantity</span>
                                                                {(() => {
                                                                    const qtyValue = watch("no_of_units") || 1;
                                                                    const qtyWidth = Math.max(186, 124 + String(qtyValue).length * 24);
                                                                    return (
                                                                        <div className="quantity text-center mb-3" style={{ width: `${qtyWidth}px` }}>
                                                                            {
                                                                                isEditingQty ? (
                                                                                    <input
                                                                                        autoFocus
                                                                                        type="number"
                                                                                        className="input-text qty text"
                                                                                        {...register("no_of_units", {
                                                                                            value: 1,
                                                                                            onChange: (event) => {
                                                                                                const qty = parseInt(event.target.value, 10);

                                                                                                if (!qty || qty < 1) return;

                                                                                                if (
                                                                                                    !productDetail?.sell_after_out_of_stock &&
                                                                                                    productDetail?.available_units &&
                                                                                                    qty > productDetail.available_units
                                                                                                ) {
                                                                                                    setValue("no_of_units", productDetail.available_units);
                                                                                                    setAmount(productDetail.available_units * unitPrice * 100);
                                                                                                    setPaymentFormAmount(productDetail.available_units * unitPrice);
                                                                                                } else {
                                                                                                    setValue("no_of_units", qty);
                                                                                                    setAmount(qty * unitPrice * 100);
                                                                                                    setPaymentFormAmount(qty * unitPrice);
                                                                                                }
                                                                                            },
                                                                                        })}
                                                                                        onBlur={() => setIsEditingQty(false)}
                                                                                    />
                                                                                ) : (
                                                                                    <div
                                                                                        className="qty-display"
                                                                                        onClick={() => setIsEditingQty(true)}
                                                                                    >
                                                                                        {qtyValue}
                                                                                    </div>
                                                                                )
                                                                            }
                                                                            <div className="_qty" style={{ '--qty-primary-color': productDetail?.primary_color || '#005B97' }}>
                                                                                <a className="minus cursor-pointer" onClick={() => toggleQuantity('decrement')}>-</a>
                                                                                <a className="plus cursor-pointer" onClick={() => toggleQuantity('increment')}>+</a>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })()}
                                                                </>
                                                                : ""
                                                            }
{/*                                                        
                                                        {
                                                            productDetail?.available_units > 0 && !productDetail?.sell_after_out_of_stock ? 
                                                            <p className='text-center mb-0 f-xsmal'>{productDetail?.available_units} available</p> : ''
                                                        }
                                                         */}
                                                                                                            {
                                                            productDetail?.sell_after_out_of_stock || 
                                                            (productDetail?.available_units === undefined || productDetail?.available_units > 0) ? 
                                                            <div
                                                                className='mt-3 p-1  text-center d-flex flex-column align-items-center total-unit-purchased'
                                                                style={{ background: getBgColor(productDetail?.primary_color) || '#eef7f5' }}
                                                            >
                                                            <div className='d-flex justify-content-center flex-row align-item-center mt-1'>
                                                            <span className='me-1'>{CURRENCY_CODE_SIGN_MAPPING[productDetail?.currency]}</span><span className='f-28 text-black'>{(paymentFormAmount)}</span>
                                                            </div>
                                                            <p className='mb-0 total-label' >Total</p>
                                                        </div> : ''
                                                        }
                                                        
                                                        {/* donor comments section  */}     
                                                        {/* <h6 className='text-center mt-2'>Total: ({productDetail?.price_per_unit} x {getValues().no_of_units}) = ${amount}</h6> */}
                                                    </div>

                                                    {
                                                        !productDetail?.sell_after_out_of_stock && 
                                                        productDetail?.available_units <= 0 ? 
                                                        <div className='text-center'>

                                                            <p className='text-bold text-center mb-0 text-danger mt-2'>This product is sold out</p> 
                                                            <p className='text-center mb-0'>If you are willing to donate, you can visit our
                                                            <a className='mx-1 text-cobalt-light text-bold' 
                                                            href={`/masjid/store/${productDetail?.masjid_id}`}>products</a>page
                                                            </p>
                                                            <button  onClick={(() => {
                                                                window.open(productDetail?.website ? productDetail?.website : 'https://mymasjidal.com/', '_self', '');
                                                            })}
                                                                    style={{
                                                                        backgroundColor: productDetail?.primary_color ? (productDetail?.primary_color) : '#005B97',
                                                                        borderBottom: productDetail?.primary_color ? ('2px solid ' + productDetail?.primary_color) : '',
                                                                        '--primary': productDetail?.primary_color ? productDetail?.primary_color : '#005B97',
                                                                        '--primary-hover': getHoverColor(productDetail?.primary_color ? productDetail?.primary_color : '#005B97'),
                                                                        '--primary-text': getTextColorByBG(productDetail?.primary_color ? productDetail?.primary_color : '#005B97'),
                                                                    }}
                                                                    type="button" className={`btn btn-md w-75 mt-2 text-white btn-step-one`}>
                                                                    <span>
                                                                        <span className='f-18 mx-4'>Close</span>
                                                                    </span>
                                                                </button>
                                                        </div>
                                                         : 
                                                         <div className=" mt-1">
                                                            <hr className="my-4 full-divider" style={{ marginRight: '-10px', width: 'calc(100% + 70px)',  }} />
                                                        <div className="col-lg-12 mt-4">
                                                            <div className="text-center position-relative">
                                                            {
                                                                    productDetail?.activate_pledge ? 
                                                                    <button disabled={stripeButtonElementLoader}
                                                                    onClick={async () => {
                                                                        const isDonorComments = await trigger('donor_comments');          
                                                                            donorInfoRef?.current?.setPayLater(true);
                                                                            setFormStep('info');
                                                                        
                                                                        // productDetail?.google_apple_pay && isGoogleApplePay ?
                                                                        // setFormStep('request_button') : setFormStep('info');
                                                                    }}
                                                                    style={{
                                                                        // backgroundColor: productDetail?.primary_color ? (productDetail?.primary_color) : '#005B97',
                                                                        // borderBottom: productDetail?.primary_color ? ('2px solid ' + productDetail?.primary_color) : '',
                                                                        // borderRadius: "8px",
                                                                       '--primary': productDetail?.primary_color ? (productDetail?.primary_color) : '#005B97',
                                                                       '--primary-hover': getHoverColor(productDetail?.primary_color),
                                                                       '--primary-text': getTextColorByBG(productDetail?.primary_color),
                                                                       borderRadius: '8px',
                                                                    }}
                                                                    type="button" className={`btn btn-md d-flex align-items-center justify-content-center w-100 text-white btn-step-one mb-3`}>
                                                                    <span>
                                                                        <span className='f-18 mx-4'>
                                                                            Pay Later (Pledge)
                                                                        </span> 
                                                                    </span>
                                                                </button> : ''
                                                                }
                                                                <button
                                                                disabled={stripeButtonElementLoader}
                                                                 onClick={async () => {            
                                                                        if(customFields?.length > 0){
                                                                            setFormStep('custom_fields');
                                                                        }else if(productDetail?.google_apple_pay && isGoogleApplePay){
                                                                            setFormStep('request_button')    
                                                                        }else{
                                                                            setFormStep('info');
                                                                        }

                                                                        donorInfoRef?.current?.setPayLater(false);                                 
                                                                    
                                                                    // productDetail?.google_apple_pay && isGoogleApplePay ?
                                                                    // setFormStep('request_button') : setFormStep('info');
                                                                }}
                                                                    style={{
                                                                        '--primary': productDetail?.primary_color,
                                                                        '--primary-hover': getHoverColor(productDetail?.primary_color),
                                                                        '--primary-text': getTextColorByBG(productDetail?.primary_color),
                                                                        borderRadius: '8px',
                                                                    }}
                                                                    type="button" className={`btn btn-md d-flex align-items-center justify-content-center w-100 text-white btn-step-one`}>
                                                                    <span>
                                                                        <span className='f-18 mx-4'>
                                                                            <span className='f-18 mx-2'>{productDetail?.activate_pledge ? 'Pay Now' : 'Next'}</span>
                                                                        </span>
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                   
                                                </div>

                                                {/* custom fields wrapper start */}
                                                {
                                                    customFields?.length > 0 &&  productDetail?.donation_amount?.campaign_id ?
                                                        <div className={formStep !== "custom_fields" ? "d-none" : `step-content ${navDirection === "forward" ? "slide-forward" : "slide-backward"}`}>
                                                            <DynamicFieldsWrapper
                                                            entityInfo={{
                                                                    entity_id: productDetail?.donation_amount?.campaign_id
                                                                }}
                                                                isTitle={false}
                                                                customFieldAction={customFieldAction}
                                                                settings={productDetail}
                                                                control={control} fieldList={customFields}
                                                                borderColor={productDetail?.primary_color}
                                                                boxShadowColor={productDetail?.box_shadow_color}
                                                                /></div> : ''
                                                }
                                                {/* custom fields wrapper end */}
                                               <div className={formStep !== "request_button" ? "d-none" : `step-content ${navDirection === "forward" ? "slide-forward" : "slide-backward"}`}>

                                                    {/*  implementing new logic for stripe button element start*/}
                                                    {
                                                        productDetail?.default_payment_processor === 'Stripe' ?
                                                    <Elements stripe={stripePromise}>
                                                        <PaymentRequestForm
                                                        key={paymentFormAmount}
                                                        setStripeButtonElementLoader={setStripeButtonElementLoader}
                                                        formStep={formStep}
                                                            selectedDonationType={'One-Time'}
                                                            onPaymentSuccess={onPaymentSuccess}
                                                            returnDonationPayload={returnDonationPayload}
                                                            setPaymentFlow={setForm}
                                                            options={options}
                                                            amount={paymentFormAmount}
                                                            campaignDetail={productDetail}
                                                        />
                                                    </Elements> : ""
                                                    }

                                                    {/*  implementing new logic for stripe button element end*/}
                                                </div>

                                                {/* pledge user info start */}
                                                {/* <div className={formStep !== 'info' ? 'd-none' : ''}> */}
                                               <div className={formStep !== "info" ? "d-none" : `step-content ${navDirection === "forward" ? "slide-forward" : "slide-backward"}`}>
                                                    <PledgeUserInfo ref={donorInfoRef}
                                                        setFormStep={setFormStep}
                                                        pledgeID={pledgeID}
                                                        fieldValidations={{}}
                                                        errors={errors}
                                                        donorInfo={validateDonorInfo}
                                                        returnSelectedAmount={returnSelectedAmount}
                                                        form={getValues()}
                                                        selectedDonationType={'One-Time'}
                                                        campaignDetail={productDetail} />
                                                </div>

                                                {
                                                    pledgeID && formStep === 'info' ? 
                                                    <div className='row'>
                                                        <div className="col-12 border-bottom mb-3">
                                                            <h6 className="text-bold">Pledge Information</h6>
                                                        </div>
                                                        <div className='col-12'>
                                                            <dt className='text-black'>Amount Pledged</dt>
                                                            <dd className='text-black'>${pledgeInfo?.amount / 100}</dd>
                                                            <dt className='text-black'>Donation Interval</dt>
                                                            <dd className='text-black'>${pledgeInfo?.donation_type}</dd>
                                                        </div>
                                                    </div> : ''
                                                }
                                            {/* 
                                            <div className={formStep !== 'info' ? 'd-none' : ''}>
                                                <DonorUserInfo
                                                    errors={errors}
                                                    donorInfo={validateDonorInfo}
                                                    campaignDetail={productDetail} />
                                            </div> */}
                                                {/* pledge user info end */}

                                                <div className={`col-12 ${formStep !== "payment" ? "d-none" : `step-content ${navDirection === "forward" ? "slide-forward" : "slide-backward"}`}`}>
                                                    <div className='d-flex justify-content-between align-items-center'>
                                                        <div className="me-1">
                                                            <img src="../../img/masjid/visa.png" className='w-100' alt="Stripe Logo" />
                                                        </div>
                                                        <div className="me-1">
                                                            <img src="../../img/masjid/master.png" className='w-100' alt="Stripe Logo" />
                                                        </div>
                                                        <div className="me-1">
                                                            <img src="../../img/masjid/amex.png" className='w-100' alt="Stripe Logo" />
                                                        </div>
                                                        <div className="me-1">
                                                            <img src="../../img/masjid/discover.png" className='w-100' alt="Stripe Logo" />
                                                        </div>
                                                        <div className="me-1">
                                                            <img src="../../img/masjid/jcb.png" className='w-100' alt="Stripe Logo" />
                                                        </div>
                                                        <div className="me-1">
                                                            <img src="../../img/masjid/union_pay.png" className='w-100' alt="Stripe Logo" />
                                                        </div>
                                                    </div>

                                                    {/* render payment form start */}

                                                    <div className="mt-4">
                                                        {
                                                            productDetail?.id ?
                                                            productDetail?.default_payment_processor === 'Square' ? 
                                                            <SquareCard
                                                            squareInstance={squareInstance}
                                                            ref={requestFormRef}
                                                                formStep={formStep}
                                                                setAmount={setAmount}
                                                                formValues={getValues()}
                                                                fieldsWatcher={fieldsWatcher}
                                                                returnSelectedAmount={returnSelectedAmount}
                                                                onPaymentSuccess={onPaymentSuccess}
                                                                selectedDonationType={'One-Time'}
                                                                campaignDetail={productDetail}
                                                                returnDonationPayload={returnDonationPayload}

                                                                setStripeButtonElementLoader={setStripeButtonElementLoader}
                                                                options={options}
                                                             /> : <Elements key={paymentFormAmount} stripe={stripePromise} options={{
                                                                    mode: 'payment',
                                                                    amount,
                                                                    currency: productDetail?.currency,
                                                                    paymentMethodCreation: 'manual',
                                                                    // Fully customizable with appearance API.
                                                                    appearance: appearance,
                                                                }}>
                                                                    {/* adding payment options for card and google pay apple pay */}
                                                                    <PaymentForm
                                                                        ref={requestFormRef}
                                                                        formStep={formStep}
                                                                        amount={amount}
                                                                        paymentFormAmount={paymentFormAmount}
                                                                        setAmount={setAmount}
                                                                        formValues={getValues()}
                                                                        fieldsWatcher={fieldsWatcher}
                                                                        returnSelectedAmount={returnSelectedAmount}
                                                                        onPaymentSuccess={onPaymentSuccess}
                                                                        selectedDonationType={''}
                                                                        campaignDetail={productDetail}
                                                                        returnDonationPayload={returnDonationPayload}
                                                                        clientSecret={options?.clientSecret}
                                                                    />
                                                                </Elements> : ''
                                                                
                                                        }
                                                        
                                                    </div>
                                                    {/* render payment form end */}
                                                </div>

                                                <div className={`row ${formStep !== "confirmation" ? "d-none" : `step-content ${navDirection === "forward" ? "slide-forward" : "slide-backward"}`}`}>
                                                <div className="col-12 p-0">

                                                    {/* Header */}
                                                    <div
                                                    className="text-center pt-3 m-0 rounded-top"
                                                    // style={{
                                                    //     backgroundColor: productDetail?.primary_color || "#7DB8E8",
                                                    // }}
                                                    >
                                                    <i
                                                        className=" fa-regular fa-circle-check "
                                                        style={{ fontSize: "60px", color: productDetail?.primary_color || "#7DB8E8", }}
                                                    ></i>

                                                    <h5 className="text-dark mt-2">
                                                        You Have {productDetail?.donation_amount?.change_label_to_pay ? "Paid" : "Donated"} ${finalScreenAmount}
                                                    </h5>
                                                    </div>

                                                    {/* Body */}
                                                    <div className="p-4  rounded-bottom">

                                                    <div
                                                        className="p-3 border text-center rounded"
                                                        style={{
                                                        background: "#fff",
                                                        }}
                                                    >
                                                        {productDetail?.success_message || "Thank you for your donation."}
                                                    </div>

                                                    <div className="row mt-4">
                                                        <div className="col-6">
                                                        <div className="border rounded p-3 h-100">
                                                            <small className="text-muted fw-bold">DATE</small>
                                                            <h6 className="mt-2 mb-0">
                                                            {new Date().toDateString()}
                                                            </h6>
                                                        </div>
                                                        </div>

                                                        <div className="col-6">
                                                        <div className="border rounded p-3 h-100">
                                                            <small className="text-muted fw-bold">
                                                            {productDetail?.donation_amount?.change_label_to_pay ? "PAID AMOUNT" : "DONATION"}
                                                            </small>

                                                            <h5
                                                            className="mt-2 mb-0"
                                                            style={{
                                                                color: productDetail?.primary_color || "#7DB8E8",
                                                            }}
                                                            >
                                                            ${finalScreenAmount}
                                                            </h5>
                                                        </div>
                                                        </div>
                                                    </div>

                                                    <button
                                                        className="btn w-100 mt-4"
                                                        style={{
                                                        backgroundColor: productDetail?.primary_color || "#7DB8E8",
                                                        color: getTextColorByBG(productDetail?.primary_color || "#7DB8E8"),
                                                        borderColor: productDetail?.primary_color || "#7DB8E8",
                                                        borderRadius: "8px",
                                                        }}
                                                        onClick={() =>
                                                        window.open(
                                                            productDetail?.website || "https://mymasjidal.com/",
                                                            "_self"
                                                        )
                                                        }
                                                    >
                                                        Close
                                                    </button>
                                                    </div>
                                                </div>
                                                </div>

                                                {
                                                    donorInfoRef?.current?.payLater ? 
                                                    <PledgeConfirmation 
                                                    formStep={formStep}
                                                    returnSelectedAmount={returnSelectedAmount}
                                                    campaignDetail={productDetail}
                                                     /> : ''
                                                }
                                            </div>
                                        </div>
                                        <div className='product-widget-footer text-center'>
                                            {productDetail?.donation_amount?.compliance ?
                                            <p className='mb-0' style={{ whiteSpace: 'pre-line' }}>{productDetail?.donation_amount?.compliance}</p> : ''}
                                        <img
                                            className='footer-masjidal-logo'
                                            src='../img/masjid/masjidal-logo-new.png'
                                            alt='Masjidal'
                                            /> <br />
                                            <a href='https://masjidal.com/' target='_blank'>Powered by Masjidal</a> 
                                            
                                        </div>
                                    </div>

                                </div>

                            }
                            </div>
                    </FormProvider> : ''
            }


        </>


    );
}

export default ProductDonationWidget;
